import gql from 'graphql-tag';

export default gql`
  fragment preleadMasterSearchConditionFilterCustomizeItemFragment on PreleadMasterSearchConditionFilterCustomizeItem {
    id
    value
    values
    from
    to
    startDate
    endDate
  }
`;
